import { render, staticRenderFns } from "./ModalSlides.vue?vue&type=template&id=43b37bc1&scoped=true&"
import script from "./ModalSlides.vue?vue&type=script&lang=js&"
export * from "./ModalSlides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b37bc1",
  null
  
)

export default component.exports